import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormatUtils from '@wix/wixrest-utils/dist/NumberFormatUtils';
import { Input } from 'wix-style-react';

export class CurrencyInput extends Component {
  constructor(props) {
    super(props);
    const { value = '' } = this.props;
    this.state = {
      formattedInput: this.formatNumberToString(value / 100),
    };
  }

  isValidInput = (string) => {
    return string === '' || !isNaN(this.formatStringToNumber(string.toString()));
  };

  formatStringToNumber = (string) => {
    return NumberFormatUtils.parse(string, this.props.locale);
  };
  formatNumberToString = (number) => {
    return NumberFormatUtils.format(number, null, this.props.locale);
  };

  onChange = (e) => {
    if (e.target.value === '') {
      this.setState({ formattedInput: '0' });
      this.setState({ formattedInput: '0' });

      this.props.onChange(0);
      return;
    }

    if (!this.isValidInput(e.target.value)) {
      return;
    }

    const inputString = e.target.value.toString();
    const isDecimal = inputString.slice(-1) === '.' || inputString.slice(-1) === ',';
    const isZero = inputString.slice(-2) === '.0' || inputString.slice(-2) === ',0';
    const numericInput = this.formatStringToNumber(inputString);
    const formattedInput = isDecimal || isZero ? inputString : this.formatNumberToString(numericInput);
    this.props.onChange(10 * numericInput * 10);
    this.setState({
      formattedInput,
    });
  };

  getValueToDisplay = () => {
    // we need to keep local input state because we want to display '.' ,',' mid typing, so sometimes we will display local input value
    // and only when out global state value for this changed from outside the component we use it
    const { formattedInput } = this.state;
    const { value } = this.props;
    const stringInput = value || value === 0 ? this.formatNumberToString(value / 100) : formattedInput;
    return this.formatStringToNumber(stringInput) === this.formatStringToNumber(formattedInput)
      ? formattedInput
      : stringInput;
  };

  render() {
    const displayValue = this.getValueToDisplay();
    const { prefix, className, dataHook = 'currency-input' } = this.props;
    return (
      <Input
        ref={this.props.innerRef}
        dataHook={dataHook}
        className={className}
        prefix={prefix}
        onChange={this.onChange}
        value={displayValue}
      />
    );
  }
}

CurrencyInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  locale: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
};
